module.exports = __webpack_public_path__ + "static/fast100-c67a198f96ab3f33b8be36f342511a2a.svg";